import React from 'react';

const sizeMap = {
  sm: 32,
  md: 48,
  lg: 64,
  xl: 96,
  hero: 128,
};

export const Logo = ({ size = 'md' }) => {
  const px = sizeMap[size] || sizeMap.md;

  return (
    <div className="relative shrink-0" style={{ width: px, height: px }}>
      <img
        src="/logo.png"
        alt="The Moon Media"
        className="w-full h-full object-contain"
        style={{ filter: 'drop-shadow(0 0 15px rgba(34, 197, 94, 0.4))' }}
      />
    </div>
  );
};
